














import { defineComponent, computed, onMounted, onUpdated, ref } from "@vue/composition-api";
import { sciIconModePostfix } from "@/const";

export default defineComponent({
  name: "BaseIcon",
  props: {
    fontSize: { type: [String, Number] },
    color: { type: String },
    gradient: { type: Boolean, default: false },
  },
  setup(props, { slots }) {
    const iconName = ref("");

    const updateIconName = () => {
      const slot = slots.default?.();
      const raw = slot && slot[0]?.text;
      iconName.value = raw ? raw.trim() : "";
    };

    onMounted(updateIconName);
    onUpdated(updateIconName);

    const iconType = computed(() => (iconName.value ? iconName.value.split("-")[0] : ""));

    const normalizedFontSize = computed(() => {
      let v = props.fontSize;
      if (typeof v === "string" && !isNaN(parseFloat(v))) {
        v = parseFloat(v);
      }
      if (typeof v === "number") return v + "px";
      return v;
    });

    const imageSrc = computed(() => {
      const name = iconName.value;
      if (!name) return null;

      const sciMatch =
        /sci-color.*/.test(name) ||
        new RegExp(`sci-.*-(${sciIconModePostfix.DARK}|${sciIconModePostfix.LIGHT}).*`).test(name);

      return sciMatch ? `/img/icons/${name}.svg` : null;
    });

    const spanClasses = computed(() => {
      const arr: string[] = [iconName.value];
      if (props.gradient) arr.push("__gradient");
      if (iconType.value === "msr" && iconName.value.split("-")[2] === "filled") arr.push("__filled");
      return arr;
    });

    const styles = computed(() => {
      const styleList: Record<string, any> = {};

      if (normalizedFontSize.value) {
        styleList.fontSize = normalizedFontSize.value;
      }

      if (props.color) {
        styleList.color = props.color;
      }

      return styleList;
    });

    return {
      iconName,
      imageSrc,
      spanClasses,
      styles,
      iconType,
    };
  },
});
